import React from 'react';
import './SettingsPanel.css';
import { useSettings } from './SettingsContext';

const GearIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
);

const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);

export const SettingsButton = () => {
    const { isSettingsOpen, setIsSettingsOpen } = useSettings();
    return (
        <button className="settings-toggle-btn" onClick={() => setIsSettingsOpen(!isSettingsOpen)} title="Brand Settings">
            <GearIcon />
        </button>
    );
};

const SettingsPanel = () => {
    const { settings, updateSetting, resetToDefaults, isSettingsOpen, setIsSettingsOpen } = useSettings();

    if (!isSettingsOpen) return null;

    return (
        <>
            <div className="settings-overlay" onClick={() => setIsSettingsOpen(false)} />
            <div className="settings-panel">
                <div className="settings-header">
                    <h2>Brand Settings</h2>
                    <button className="settings-close-btn" onClick={() => setIsSettingsOpen(false)}>
                        <CloseIcon />
                    </button>
                </div>

                <div className="settings-content">
                    <div className="settings-grid">
                        <div className="settings-column">
                            <div className="settings-group">
                                <h3>Brand Identity</h3>
                                <label>
                                    App Name
                                    <input type="text" value={settings.brand.name} onChange={(e) => updateSetting('brand', 'name', e.target.value)} />
                                </label>
                                <label>
                                    Tagline
                                    <input type="text" value={settings.brand.tagline} onChange={(e) => updateSetting('brand', 'tagline', e.target.value)} />
                                </label>
                                <label>
                                    Logo URL
                                    <input type="text" value={settings.brand.logo} onChange={(e) => updateSetting('brand', 'logo', e.target.value)} />
                                </label>
                                <label>
                                    Logo Width (e.g., 180px, 100%)
                                    <input type="text" value={settings.brand.logoWidth} onChange={(e) => updateSetting('brand', 'logoWidth', e.target.value)} />
                                </label>
                                <label>
                                    Favicon URL
                                    <input type="text" value={settings.brand.favicon || ''} onChange={(e) => updateSetting('brand', 'favicon', e.target.value)} />
                                </label>
                            </div>

                            <div className="settings-group">
                                <h3>Text</h3>
                                <label>
                                    Main Title
                                    <input type="text" value={settings.text.appTitle} onChange={(e) => updateSetting('text', 'appTitle', e.target.value)} />
                                </label>
                            </div>

                            <div className="settings-group">
                                <h3>Core Colors</h3>
                                <label>
                                    Primary Color
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.primary} onChange={(e) => updateSetting('colors', 'primary', e.target.value)} />
                                        <input type="text" value={settings.colors.primary} onChange={(e) => updateSetting('colors', 'primary', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Primary Hover Color
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.primaryHover} onChange={(e) => updateSetting('colors', 'primaryHover', e.target.value)} />
                                        <input type="text" value={settings.colors.primaryHover} onChange={(e) => updateSetting('colors', 'primaryHover', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Background Color
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.background} onChange={(e) => updateSetting('colors', 'background', e.target.value)} />
                                        <input type="text" value={settings.colors.background} onChange={(e) => updateSetting('colors', 'background', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Card Background
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.backgroundCard} onChange={(e) => updateSetting('colors', 'backgroundCard', e.target.value)} />
                                        <input type="text" value={settings.colors.backgroundCard} onChange={(e) => updateSetting('colors', 'backgroundCard', e.target.value)} />
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="settings-column">
                            <div className="settings-group">
                                <h3>Navbar & Footer</h3>
                                <label>
                                    Navbar Background
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.navbarBackground} onChange={(e) => updateSetting('colors', 'navbarBackground', e.target.value)} />
                                        <input type="text" value={settings.colors.navbarBackground} onChange={(e) => updateSetting('colors', 'navbarBackground', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Navbar Text
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.navbarText} onChange={(e) => updateSetting('colors', 'navbarText', e.target.value)} />
                                        <input type="text" value={settings.colors.navbarText} onChange={(e) => updateSetting('colors', 'navbarText', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Footer Background
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.footerBackground} onChange={(e) => updateSetting('colors', 'footerBackground', e.target.value)} />
                                        <input type="text" value={settings.colors.footerBackground} onChange={(e) => updateSetting('colors', 'footerBackground', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Footer Text
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.footerText} onChange={(e) => updateSetting('colors', 'footerText', e.target.value)} />
                                        <input type="text" value={settings.colors.footerText} onChange={(e) => updateSetting('colors', 'footerText', e.target.value)} />
                                    </div>
                                </label>
                            </div>

                            <div className="settings-group">
                                <h3>Typography Colors</h3>
                                <label>
                                    Primary Text Color
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.textPrimary} onChange={(e) => updateSetting('colors', 'textPrimary', e.target.value)} />
                                        <input type="text" value={settings.colors.textPrimary} onChange={(e) => updateSetting('colors', 'textPrimary', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Secondary Text Color
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.textSecondary} onChange={(e) => updateSetting('colors', 'textSecondary', e.target.value)} />
                                        <input type="text" value={settings.colors.textSecondary} onChange={(e) => updateSetting('colors', 'textSecondary', e.target.value)} />
                                    </div>
                                </label>
                            </div>

                            <div className="settings-group">
                                <h3>Verification Steps</h3>
                                <label style={{ flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={settings.liveness?.enabled !== false} onChange={(e) => updateSetting('liveness', 'enabled', e.target.checked)} />
                                    Enable Face Liveness Check
                                </label>
                                <p style={{ fontSize: '12px', color: '#888', margin: '4px 0 0 24px' }}>
                                    When disabled, the liveness and face comparison steps are removed from the workflow entirely.
                                </p>
                            </div>

                            <div className="settings-group">
                                <h3>Membership &amp; Payment flow</h3>
                                <label style={{ flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                                    <input type="checkbox" checked={settings.membership?.enabled !== false} onChange={(e) => updateSetting('membership', 'enabled', e.target.checked)} />
                                    Enable Membership Step
                                </label>
                                <label>
                                    Provider Name
                                    <input type="text" value={settings.membership?.providerName || ''} onChange={(e) => updateSetting('membership', 'providerName', e.target.value)} />
                                </label>
                                <label>
                                    Provider Icon URL
                                    <input type="text" value={settings.membership?.providerIcon || ''} onChange={(e) => updateSetting('membership', 'providerIcon', e.target.value)} />
                                </label>
                                <label>
                                    Tier 1 (Label & Price)
                                    <div className="color-picker-row">
                                        <input type="text" value={settings.membership?.tier1Label || ''} onChange={(e) => updateSetting('membership', 'tier1Label', e.target.value)} />
                                        <input type="number" placeholder="$" value={settings.membership?.tier1Price || ''} onChange={(e) => updateSetting('membership', 'tier1Price', e.target.value)} style={{ width: '80px' }} />
                                    </div>
                                </label>
                                <label>
                                    Tier 2 (Label & Price)
                                    <div className="color-picker-row">
                                        <input type="text" value={settings.membership?.tier2Label || ''} onChange={(e) => updateSetting('membership', 'tier2Label', e.target.value)} />
                                        <input type="number" placeholder="$" value={settings.membership?.tier2Price || ''} onChange={(e) => updateSetting('membership', 'tier2Price', e.target.value)} style={{ width: '80px' }} />
                                    </div>
                                </label>
                                <label>
                                    Tier 3 (Label & Price)
                                    <div className="color-picker-row">
                                        <input type="text" value={settings.membership?.tier3Label || ''} onChange={(e) => updateSetting('membership', 'tier3Label', e.target.value)} />
                                        <input type="number" placeholder="$" value={settings.membership?.tier3Price || ''} onChange={(e) => updateSetting('membership', 'tier3Price', e.target.value)} style={{ width: '80px' }} />
                                    </div>
                                </label>
                            </div>
                            <div className="settings-group">
                                <h3>Button Styles</h3>
                                <label>
                                    Button Background
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.buttonPrimary} onChange={(e) => updateSetting('colors', 'buttonPrimary', e.target.value)} />
                                        <input type="text" value={settings.colors.buttonPrimary} onChange={(e) => updateSetting('colors', 'buttonPrimary', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Button Hover
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.buttonPrimaryHover} onChange={(e) => updateSetting('colors', 'buttonPrimaryHover', e.target.value)} />
                                        <input type="text" value={settings.colors.buttonPrimaryHover} onChange={(e) => updateSetting('colors', 'buttonPrimaryHover', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Button Text
                                    <div className="color-picker-row">
                                        <input type="color" value={settings.colors.buttonText} onChange={(e) => updateSetting('colors', 'buttonText', e.target.value)} />
                                        <input type="text" value={settings.colors.buttonText} onChange={(e) => updateSetting('colors', 'buttonText', e.target.value)} />
                                    </div>
                                </label>
                                <label>
                                    Button Box Radius (px)
                                    <input type="number" min="0" max="50" value={settings.colors.buttonRadius} onChange={(e) => updateSetting('colors', 'buttonRadius', e.target.value)} />
                                </label>
                            </div>

                            <div className="settings-group">
                                <h3>Layout</h3>
                                <label>
                                    Card Box Radius (px)
                                    <input type="number" min="0" max="50" value={settings.colors.radius} onChange={(e) => updateSetting('colors', 'radius', e.target.value)} />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="settings-actions">
                        <button className="reset-button" onClick={resetToDefaults}>Reset to Defaults</button>
                        <button className="save-button" onClick={() => setIsSettingsOpen(false)}>Done</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SettingsPanel;
